import { RefObject, useEffect, useRef, useState } from "react";
import { ArrowCDownIcon16Light, XIcon16Light } from "@skbkontur/icons";
import React from "react";
import { Hint, ScrollContainer } from "react-ui";

import { useResizeObserver } from "../../../../../Helpers/ReactUtils/Hooks/UseResizeObserver";
import { AttachmentNames, Unit, UnitItem, UnitListProps } from "../FufAndAttachmentsUploadModalTypes";
import {
    DeleteBtnIcon,
    UnitListHeader,
    UnitListLi,
    UnitListTitle,
    UnitListTitleIcon,
    UnitListUl,
} from "../FufWithAttachmentsUploadModal.styles";
import { useFufAndAttachmentsUpload } from "../FufAndAttachmentsUploadContext";
import { removeByGfv } from "../FufAndAttachmentsReducer";

import { AttachmentsList } from "./AttachmentsList";

export const SCROLL_CONTAINER_HEIGHT = 425;

const serialiseUnits = (unitItems: UnitItem[], attachmentNames: AttachmentNames) => {
    const groups: Record<string, UnitItem[]> = {};

    for (const item of unitItems) {
        const gfv = item.gfv;

        if (!groups[gfv]) {
            groups[gfv] = [];
        }

        groups[gfv].push(item);
    }

    const units: Unit[] = [];

    for (const [gfv, items] of Object.entries(groups)) {
        units.push({
            gfv: gfv,
            title: attachmentNames[gfv]?.name ?? "Не распознано",
            items: items,
            index: attachmentNames[gfv]?.index ?? -2,
        });
    }

    return units.sort((a, b) => a.index - b.index);
};

const UnitListContent = ({ unit, scrollRef }: { unit: Unit; scrollRef: RefObject<ScrollContainer | null> }) => {
    const [isActive, setIsActive] = useState(true);
    const { dispatch } = useFufAndAttachmentsUpload();

    if (unit.items.length === 0) {
        return null;
    }

    return (
        <UnitListLi>
            <UnitListHeader data-tid={`unitItem-${unit.gfv}`} onClick={() => setIsActive(!isActive)}>
                <UnitListTitle>{unit.title}</UnitListTitle>
                <UnitListTitleIcon isActive={isActive}>
                    <ArrowCDownIcon16Light />
                </UnitListTitleIcon>
                <Hint text="Удалить раздел">
                    <DeleteBtnIcon onClick={() => dispatch(removeByGfv({ gfv: unit.gfv }))}>
                        <XIcon16Light />
                    </DeleteBtnIcon>
                </Hint>
            </UnitListHeader>

            {isActive && <AttachmentsList items={unit.items} scrollRef={scrollRef} />}
        </UnitListLi>
    );
};

export const UnitList = ({ setIsScrolled, filesForUpload, attachmentNames, scrollRef }: UnitListProps) => {
    const units: Unit[] = serialiseUnits(filesForUpload, attachmentNames);

    const unitsEl = units.map(unit => <UnitListContent key={unit.gfv} unit={unit} scrollRef={scrollRef} />);
    const unitListUlRef = useRef<HTMLUListElement | null>(null);
    const [height, setHeight] = useState<number | null>(null);
    const resizeObserver = useResizeObserver({
        onResize: (entries: ResizeObserverEntry[]) => {
            setHeight(entries[0]?.contentRect?.height ?? null);
        },
    });

    useEffect(() => {
        if (unitListUlRef.current) {
            resizeObserver.observe(unitListUlRef.current);
        }
    }, [unitListUlRef.current]);

    useEffect(() => {
        setIsScrolled(!!height && height > SCROLL_CONTAINER_HEIGHT);
    }, [height]);

    return <UnitListUl ref={unitListUlRef}>{unitsEl}</UnitListUl>;
};
